// Router
import { createRouter, createWebHistory } from "vue-router";
import config from "@/axios";
import { useGeneralStore } from "@/stores/generalStore";

// Base
import Body from "@/components/body";
import Login from "@/auth/login.vue";
// Inicio
import Stats from "@/pages/dashboard/stats.vue";
// Pólizas
import Polizas from "@/pages/polizas/polizas.vue";
import nuevaPoliza from "@/pages/polizas/nuevaPoliza.vue";
import detallePolizaExistente from "@/pages/polizas/detallePolizaExistente.vue";
import detallePolizaReadOnly from "@/pages/polizas/detallePolizaReadOnly.vue";
import OrdenTrabajo from "@/pages/polizas/ordenTrabajo.vue";
import estadoCuenta from "@/pages/polizas/estadoCuenta.vue";
import Contratantes from "@/pages/polizas/contratantes.vue";
import detalleContratante from "@/pages/polizas/detalleContratante.vue";
import editContratante from "@/pages/polizas/editContratante.vue";
// Asegurados
import Asegurados from "@/pages/asegurados/asegurados.vue";
import detalleAsegurado from "@/pages/asegurados/detalleAsegurado.vue";
import AseguradosRegistrados from "@/pages/asegurados/registrados.vue";
// Cobranza
import Activos from "@/pages/cobranza/activos.vue";
import PagosIndividuales from "@/pages/cobranza/pagosIndividuales.vue";
import AplicacionPagosIndividuales from "@/pages/cobranza/aplicacionPagosIndividuales.vue";
import Instalacion from "@/pages/cobranza/instalacion.vue";
// Reportes
// Proveedores
import Aseguradoras from "@/pages/proveedores/aseguradoras.vue";
import productos from "@/pages/proveedores/productos.vue";
import productosDetalle from "@/pages/proveedores/productosDetalle.vue";
// Organizaciones
import Organizaciones from "@/pages/organizaciones/organizaciones.vue";
import Unidades from "@/pages/organizaciones/unidades.vue";
import CalendarioOrganizacion from "@/pages/organizaciones/calendarioOrganizacion.vue";
// Financieros
import Bancos from "@/pages/financieros/bancos.vue";
import Instrumentos from "@/pages/financieros/instrumentos.vue";
// Geograficos
import Estados from "@/pages/geograficos/estados.vue";
import Municipios from "@/pages/geograficos/municipios.vue";
import Ciudades from "@/pages/geograficos/ciudades.vue";
import CiudadesDetail from "@/pages/geograficos/ciudadesDetail.vue";
// Biologicos
import ColorOjos from "@/pages/biologicos/colordeojos.vue";
import Tiposdesangre from "@/pages/biologicos/tiposdesangre.vue";
// Comunicados
import Notificaciones from "@/pages/notificaciones/notificaciones.vue";
// Accesos
import Usuarios from "@/pages/accesos/usuarios.vue";
import Perfiles from "@/pages/accesos/perfiles.vue";
// Soporte


// Routes
const routes = [
  { // Base
    path: "/",
    redirect: "/auth/login",
  },
  { // Dashboard
    path: "/dashboard",
    component: Body,
    children: [
      {
        path: "",
        name: "Stats",
        component: Stats,
        meta: {
          title: " SIMM | Dashboard",
        },
      },
    ],
  },
  { // Auth
    path: "/auth",    
    children: [
      {
        path: "login",
        name: "login",
        component: Login,
        meta: {
          title: " SIMM | Login",
        },
      },        
    ],
  },
  { // Pólizas
    path: "/polizas",    
    component: Body,
    children: [
      {
        path: "nuevaPoliza",
        name: "nuevasPolizas",
        component: nuevaPoliza,
        meta: {
          title: " SIMM | Nuevas Póliza",
        },
      },
      {
        path: "emitidas",
        name: "emitidasPolizas",
        component: Polizas,
        meta: {
          title: " SIMM | Pólizas Emitidas",
        },
      },
      {
        path: "detallePoliza/:id",
        name: "detallePoliza",
        component: detallePolizaExistente,
        meta: {
          title: " SIMM | Editar Póliza",
        },
      },
      {
        path: "verPoliza/:id",
        name: "verPoliza",
        component: detallePolizaReadOnly,
        meta: {
          title: " SIMM | Detalle Póliza",
        },
      },
      {
        path: "estadoCuenta/:id",
        name: "estadoCuenta",
        component: estadoCuenta,
        meta: {
          title: " SIMM | Estado de cuenta",
        },
      },
      {
        path: "ordenTrabajo/:id",
        name: "ordenTrabajo",
        component: OrdenTrabajo,
        meta: {
          title: " SIMM | Orden de Trabajo",
        },
      },
      {
        path: "/polizas/contratantes",
        name: "contratantesPolizas",
        component: Contratantes,
        meta: {
          title: " SIMM | Contratantes",
        },
      },
      {
        path: "contratantes/:id/detalle",
        name: "detalleContratante",
        component: detalleContratante,
        meta: {
          title: " SIMM | Detalle Contratante",
        },
      },
      {
        path: "contratantes/:id/editar",
        name: "editContratante",
        component: editContratante,
        meta: {
          title: " SIMM | Editar Contratante",
        },
      }
    ],
  },
  { // Organizaciones
    path: "/organizaciones",
    component: Body,
    children: [
      {
        path: "organizaciones",
        name: "organizaciones",
        component: Organizaciones,
        meta: {
          title: " SIMM | Organizaciones",
        },
      },
      {
        path: "unidades",
        name: "unidades",
        component: Unidades,
        meta: {
          title: " SIMM | Unidades",
        },
      },
      {
        path: "calendario/:id",
        name: "calendarioOrganizacion",
        component: CalendarioOrganizacion,
        meta: {
          title: " SIMM | Calendario de Organización",
        },
      },
    ],
  },
  { // Asegurados
    path: "/asegurados",
    component: Body,
    children: [
      {
        path: "nuevos",
        name: "nuevos",
        component: Asegurados,
        meta: {
          title: " SIMM | Nuevos",
        },
      },
      {
        path: "registrados",
        name: "registrados",
        component: AseguradosRegistrados,
        meta: {
          title: " SIMM | Asegurados",
        },
      },
      {
        path: "detalleAsegurado/:id",
        name: "detalleAsegurado",
        component: detalleAsegurado,
        meta: {
          title: " SIMM | Detalle Asegurado",
        },
      },      
    ],
  },
  { // Cobranza
    path: "/cobranza",
    component: Body,
    children: [
      {
        path: "estatus",
        name: "estatus",
        //component: Estatus,
        meta: {
          title: " SIMM | Estatus",
        },
      },
      {
        path: "activos",
        name: "activos",
        component: Activos,
        meta: {
          title: " SIMM | Activos",
        },
      },
      {
        path: "individual",
        name: "individual",
        component: PagosIndividuales,
        meta: {
          title: " SIMM | Pagos Individuales",
        },
      },
      {
        path: "aplicacionPagosIndividuales",
        name: "aplicacionPagosIndividuales",
        component: AplicacionPagosIndividuales,
        meta: {
          title: " SIMM | Aplicación de Pagos Individuales",
        },
      },
      {
        path: "instalacion",
        name: "instalacion",
        component: Instalacion,
        meta: {
          title: " SIMM | Instalación",
        },
      },
    ],
  },
  { // Proveedores
    path: "/proveedores",
    component: Body,
    children: [
      {
        path: "aseguradoras",
        name: "aseguradoras",
        component: Aseguradoras,
        meta: {
          title: " SIMM | Aseguradoras",
        },
      },
      {
        path: "productos",
        name: "productos",
        component: productos,
        meta: {
          title: " SIMM | Productos",
        },
      },
      {
        path: "productos/:id",
        name: "productosDetalle",
        component: productosDetalle,
        meta: {
          title: " SIMM | Detalle Producto",
        },
      },
    ],
  },
  { // Financieros
    path: "/financieros",
    component: Body,
    children: [
      {
        path: "bancos",
        name: "bancos",
        component: Bancos,
        meta: {
          title: " SIMM | Bancos",
        },
      },
      {
        path: "instrumentos",
        name: "instrumentos",
        component: Instrumentos,
        meta: {
          title: " SIMM | Instrumentos",
        },
      },  
    ],
  },
  { // Geográficos
    path: "/geograficos",
    component: Body,

    children: [
      {
        path: "estados",
        name: "estados",
        component: Estados,
        meta: {
          title: " SIMM | Estados",
        },
      },
      {
        path: "municipios",
        name: "municipios",
        component: Municipios,
        meta: {
          title: " SIMM | Municipios",
        },
      },
      {
        path: "ciudades",
        name: "ciudades",
        component: Ciudades,
        meta: {
          title: " SIMM | Ciudades",
        },
      },
      {
        path: "ciudadesDetail/:id",
        name: "ciudadesDetail",
        component: CiudadesDetail,
        meta: {
          title: " SIMM | Ciudad Detalle",
        },
      },
    ],
  },
  { // Biológicos
    path: "/biologicos",
    component: Body,
    children: [      
      {
        path: "colorojos",
        name: "Color de ojos",
        component: ColorOjos,
        meta: {
          title: " SIMM | Color de Ojos",
        },
      },
      {
        path: "tiposdesangre",
        name: "Tipos de sangre",
        component: Tiposdesangre,
        meta: {
          title: " SIMM | Tipos de Sangre",
        },
      },
    ],
  },
  { // Comunicados
    path: "/configuracion",
    component: Body,
    children: [
      {
        path: "notificaciones",
        name: "notificaciones",
        component: Notificaciones,
        meta: {
          title: " SIMM | Notificaciones",
        },
      },
    ],
  },
  { // Accesos
    path: "/accesos",
    component: Body,
    children: [
      {
        path: "usuarios",
        name: "usuarios",
        component: Usuarios,
        meta: {
          title: " SIMM | Usuarios",
        },
      },
      {
        path: "perfiles",
        name: "perfiles",
        component: Perfiles,
        meta: {
          title: " SIMM | Perfiles",
        },
      },
    ],
  },
]

// Create Router
const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation Guards
const publicPaths = ["/auth/login", "/auth/register"];

// Valida la sesión del usuario antes de cada ruta
router.beforeEach(async (to, from, next) => {
  if (to.meta.title) document.title = to.meta.title;

  // Permitir acceso a rutas públicas
  if (publicPaths.includes(to.path)) {
    return next();
  }

  // Verificar si hay datos en el store (sesión activa)
  const generalStore = useGeneralStore();
  if (generalStore.upn) {
    return next();
  }

  // Si no hay datos en el store, verificar con el backend
  try {
    const response = await config.get('validate', {
      withCredentials: true
    });
    
    if (response.data && response.data.authenticated) {
      // Cargar datos del usuario en el store
      generalStore.setUserData({
        id: response.data.id,
        upn: response.data.upn,
        role: response.data.role,
      });
      return next();
    } else {
      return next("/auth/login");
    }
  } catch (error) {
    return next("/auth/login");
  }
});

export default router;